import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import DetailListItem from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import onboardingStyles from '../../../../../../Onboarding/Pages/Survey/SurveyStep/StepLibrary/DetailList/Layout/styles';

const styles = (theme) => ({
  ...onboardingStyles(theme),
  root: {
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  addButtonRow: {
    width: '100%',
    textAlign: 'center',
  },
  addButtonRowHidden: {
    display: 'none',
  },
  addButton: {},
  surveyStepHeader: {
    padding: 0,
  },
  surveyStepHeaderTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  surveyStepHeaderSubtitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginTop: 0,
    marginBottom: theme.spacing(4),
  },
});

function Content({
  classes,
  loadLink,
  setCollection,
  refreshCollection,
}) {
  const { displayErrorMessage } = useSnackbarContext();
  const {
    resource,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  const hasNewItemRelationship = !!resource.relationship(fr.relationships.newItem.name);

  async function handleDelete(detailItemResource) {
    try {
      await detailItemResource.delete();
    } catch (e) {
      displayErrorMessage(e, 'Failed to delete item');
    }
    await refreshCollection();
  }

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      <SurveyStepHeader
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
        alertTitle={resource.attr('alertTitle')}
        alertDescription={resource.attr('alertDescription')}
        titleTest={'wizard-step-title'}
        subtitleTest={'wizard-step-subtitle'}
        classes={{
          root: classes.surveyStepHeader,
          title: classes.surveyStepHeaderTitle,
          subtitle: classes.surveyStepHeaderSubtitle,
        }}
      />
      <Box className={classes.content}>
        {resource.attr('detailItems').resources().list().map((detailItemResource) => {
          return (
            <DetailListItem
              key={detailItemResource.id()}
              onClick={() => {
                loadLink(detailItemResource.relationship(fr.relationships.subStep.name).link('related'));
              }}
              className={classes.listItem}
              resource={detailItemResource}
              test={'wizard-detail-list-item'}
              onDelete={detailItemResource.meta().action('DELETE') ? () => handleDelete(detailItemResource) : undefined}
            />
          );
        })}
        <div
          className={classNames(classes.addButtonRow, {
            [classes.addButtonRowHidden]: !hasNewItemRelationship,
          })}
          test={'survey-detail-add-list-item-button'}
        >
          <FDSecondaryActionButton
            icon="add"
            iconPosition="start"
            size="md"
            label={resource.relationship(fr.relationships.newItem.name)?.meta('prompt') || 'Add New Item'}
            onClick={async () => {
              const newItemCollection = await resource.relationship(fr.relationships.newItem.name).link('related').get();
              setCollection(newItemCollection);
            }}
          />
        </div>
      </Box>
    </div>
  );
}

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  loadLink: PropTypes.func.isRequired,
  setCollection: PropTypes.func.isRequired,
  refreshCollection: PropTypes.func.isRequired,
};

Content.defaultProps = {
};

export default withStyles(styles)(Content);
